'use client'

import React from 'react'

import {MobileSidebar} from '@/src/shared/ui/layout/ui/mobile-sidebar'
import {observer} from 'mobx-react'
import {useLayoutStore} from '@/src/shared/ui/layout'
import {Routes} from '@/src/config/routes'
import {fillNavLink} from '@/src/shared/utils/functions'

const HeaderMobileLinks = observer(() => {
  const layoutStore = useLayoutStore()

  const mobileMenu = (layoutStore.data.header.menu.header_mobile ?? [])
    .map((item, i) => ({
      ...item,
      label: item.title,
      key: i,
      url: Routes.static(item.url, layoutStore.data.static_pages ?? []),
      href: Routes.static(item.url, layoutStore.data.static_pages ?? []),
    }))
    .map((item, index) => fillNavLink(item, index, 'mobile-menu', undefined, true))

  return <MobileSidebar links={mobileMenu} />
})

export default HeaderMobileLinks
